/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Brand } from '../models/Brand';
import type { BrandAuthRequest } from '../models/BrandAuthRequest';
import type { BrandCatalogRequest } from '../models/BrandCatalogRequest';
import type { BrandConfirmDispatchRequest } from '../models/BrandConfirmDispatchRequest';
import type { BrandCreateOrderRequest } from '../models/BrandCreateOrderRequest';
import type { BrandDispatchRequest } from '../models/BrandDispatchRequest';
import type { BrandLineLoginRequest } from '../models/BrandLineLoginRequest';
import type { BrandOperationsOrder } from '../models/BrandOperationsOrder';
import type { BrandOrderResponse } from '../models/BrandOrderResponse';
import type { BrandPriceConfirmation } from '../models/BrandPriceConfirmation';
import type { BrandPublicResponse } from '../models/BrandPublicResponse';
import type { BrandQuoteResponse } from '../models/BrandQuoteResponse';
import type { BrandSession } from '../models/BrandSession';
import type { BrandSettingsRequest } from '../models/BrandSettingsRequest';
import type { BrandTripRequest } from '../models/BrandTripRequest';
import type { Team } from '../models/Team';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandsService {
    /**
     * @param domain
     * @returns BrandPublicResponse OK
     * @throws ApiError
     */
    public static getApiBrandsResolve(
        domain?: string,
    ): CancelablePromise<BrandPublicResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/resolve',
            query: {
                'domain': domain,
            },
        });
    }
    /**
     * @returns Team OK
     * @throws ApiError
     */
    public static getApiBrandsTeams(): CancelablePromise<Array<Team>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/teams',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Brand OK
     * @throws ApiError
     */
    public static getApiBrands(): CancelablePromise<Array<Brand>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @returns BrandSettingsRequest OK
     * @throws ApiError
     */
    public static getApiBrandsSettings(
        brandId: number,
    ): CancelablePromise<BrandSettingsRequest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/{brandId}/settings',
            path: {
                'brandId': brandId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @param requestBody
     * @returns Brand OK
     * @throws ApiError
     */
    public static putApiBrandsSettings(
        brandId: number,
        requestBody?: BrandSettingsRequest,
    ): CancelablePromise<Brand> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/brands/{brandId}/settings',
            path: {
                'brandId': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @param requestBody
     * @returns BrandSession OK
     * @throws ApiError
     */
    public static postApiBrandsRegister(
        brandId: number,
        requestBody?: BrandAuthRequest,
    ): CancelablePromise<BrandSession> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/{brandId}/register',
            path: {
                'brandId': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param brandId
     * @param requestBody
     * @returns BrandSession OK
     * @throws ApiError
     */
    public static postApiBrandsLogin(
        brandId: number,
        requestBody?: BrandAuthRequest,
    ): CancelablePromise<BrandSession> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/{brandId}/login',
            path: {
                'brandId': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param brandId
     * @param requestBody
     * @returns BrandSession OK
     * @throws ApiError
     */
    public static postApiBrandsLineLogin(
        brandId: number,
        requestBody?: BrandLineLoginRequest,
    ): CancelablePromise<BrandSession> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/{brandId}/line-login',
            path: {
                'brandId': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param brandId
     * @returns BrandCatalogRequest OK
     * @throws ApiError
     */
    public static getApiBrandsCatalog(
        brandId: number,
    ): CancelablePromise<BrandCatalogRequest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/{brandId}/catalog',
            path: {
                'brandId': brandId,
            },
        });
    }
    /**
     * @param brandId
     * @param requestBody
     * @returns BrandCatalogRequest OK
     * @throws ApiError
     */
    public static putApiBrandsCatalog(
        brandId: number,
        requestBody?: BrandCatalogRequest,
    ): CancelablePromise<BrandCatalogRequest> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/brands/{brandId}/catalog',
            path: {
                'brandId': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @param orderId
     * @returns BrandOrderResponse OK
     * @throws ApiError
     */
    public static getApiBrandsOrders(
        brandId: number,
        orderId: string,
    ): CancelablePromise<BrandOrderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/{brandId}/orders/{orderId}',
            path: {
                'brandId': brandId,
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiBrandsOrdersConfirmPrice(
        orderId: string,
        requestBody?: BrandPriceConfirmation,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/orders/{orderId}/confirm-price',
            path: {
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiBrandsOrdersResendPayment(
        orderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/orders/{orderId}/resend-payment',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiBrandsOffers(
        brandId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/{brandId}/offers',
            path: {
                'brandId': brandId,
            },
        });
    }
    /**
     * @param brandId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiBrandsOffersManage(
        brandId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/{brandId}/offers/manage',
            path: {
                'brandId': brandId,
            },
        });
    }
    /**
     * @param brandId
     * @param offerId
     * @returns any OK
     * @throws ApiError
     */
    public static putApiBrandsOffers(
        brandId: string,
        offerId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/brands/{brandId}/offers/{offerId}',
            path: {
                'brandId': brandId,
                'offerId': offerId,
            },
        });
    }
    /**
     * @param brandId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiBrandsRatesImportPreview(
        brandId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/{brandId}/rates/import-preview',
            path: {
                'brandId': brandId,
            },
        });
    }
    /**
     * @param brandId
     * @param requestBody
     * @returns BrandQuoteResponse OK
     * @throws ApiError
     */
    public static postApiBrandsQuotes(
        brandId: number,
        requestBody?: BrandTripRequest,
    ): CancelablePromise<BrandQuoteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/{brandId}/quotes',
            path: {
                'brandId': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @param requestBody
     * @returns BrandOrderResponse OK
     * @throws ApiError
     */
    public static postApiBrandsOrders(
        brandId: number,
        requestBody?: BrandCreateOrderRequest,
    ): CancelablePromise<BrandOrderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/{brandId}/orders',
            path: {
                'brandId': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @returns BrandOrderResponse OK
     * @throws ApiError
     */
    public static getApiBrandsOrders1(
        brandId: number,
    ): CancelablePromise<Array<BrandOrderResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/{brandId}/orders',
            path: {
                'brandId': brandId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @returns BrandOperationsOrder OK
     * @throws ApiError
     */
    public static getApiBrandsOrdersManage(
        brandId: number,
    ): CancelablePromise<Array<BrandOperationsOrder>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/{brandId}/orders/manage',
            path: {
                'brandId': brandId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns BrandOperationsOrder OK
     * @throws ApiError
     */
    public static getApiBrandsTeamOrders(): CancelablePromise<Array<BrandOperationsOrder>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brands/team-orders',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiBrandsOrdersDispatch(
        orderId: string,
        requestBody?: BrandDispatchRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/orders/{orderId}/dispatch',
            path: {
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiBrandsOrdersConfirm(
        orderId: string,
        requestBody?: BrandConfirmDispatchRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brands/orders/{orderId}/confirm',
            path: {
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
